import React from 'react';
import { validacionDePrecio } from '../../../Helpers/Precio';
import PasosExplicacion from '../../Common/Banners/PasosExplicacion';

function InfoAContinuacion({ precio, categoriaCredencial }) {
    return <PasosExplicacion precio={validacionDePrecio(precio)} categoriaCredencial={categoriaCredencial} />;
}

export default InfoAContinuacion;
